import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";
import moment from 'moment';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField/TextField";
import Divider from "@material-ui/core/Divider";

import {
  apollo_useStyles,
} from "../../atom/Apollo_styles";
import {
  apollo_product_master_relation_path,
  apollo_product_master_path,
} from "../../atom/Apollo_links";
import {
  ProductMasterRelation,
} from "../../pages/MASTER/MasterModel";
import {
  RequestProduct,
} from "./Apollo_MasterModel";

// 共通部品
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import ApolloIndustoryCategory, {PropsCategory} from "../../molecule/MASTER/Apollo_IndustoryCategory";
import {ApolloContext} from "../../atom/Apollo_Context";
import {LogData, ApolloEventRecord} from "../../atom/Apollo_EventRecord";
import {checkCommonInvalidTextChar} from "../../common/Apollo_CommonUtil";
// メッセージ定義
import {
  GetMessage,
  UI_MASTER_PRODUCT_EDIT,
} from "../../atom/Apollo_MesasgeDefinition";
// ドロワー(認証期間切れの場合にドロワーを閉じるため)
import {ApolloRightDrawerContext, RightDrawer} from "../../molecule/Apollo_RightDrawer";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

export default function ApolloMasterProductEdit(props: {
	productId: number,
	read: boolean,
	setRead: any,
	close: any,
	setId?: any,
	setName?: any,
	setIndustoryName?: any,
}) {
	const {read, setRead, setId, setName, setIndustoryName} = props;
	const {register, handleSubmit, errors} = useForm();
	const classes = apollo_useStyles();
	const {data, setmsg} = React.useContext(ApolloMessage);
	const [master, setMaster] = useState<ProductMasterRelation>();
	const [industoryId, setIndustoryId] = useState(0);
	const [industoryCategoryId, setIndustoryCategoryId] = useState(0);
	const {state: apolloContex} = React.useContext(ApolloContext);
	// 再読み込み
	const [reRead, setReRead] = useState(true);
	// ドロワー(認証期間切れの場合にドロワーを閉じるため)
	const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
	// リダイレクト(認証期間切れの場合にリダイレクトするため)
	const history = useHistory();

	// 商品マスタ取得
	useEffect(() => {
		// 新規登録の場合は取得しない
		if (props.productId === 0) return;
		setmsg({
			type: "loading",
			payload: {
				...data,
				loading: true,
			}
		});
		// 商品マスタ取得
		const path = apollo_product_master_relation_path + "/" + props.productId;
		ApolloAxios.get(path).then(response => {
			if (response.data.resultCode === 0) {
				setMasterData(response.data.result);
				setmsg({
					type: "all",
					payload: {
						...data,
						loading: false,
					}
				});
			} else {
				console.log(response.data.message)
				setmsg({
					type: "all",
					payload: {
						...data,
						open: true,
						type: "error",
						message: GetMessage("0",UI_MASTER_PRODUCT_EDIT,"E","0"),
						loading: false,
					}
				});
			}
		}).catch(err => {
			// 認証期間切れ判定とエラーメッセージ表示
			if (!ApolloExpired(err, GetMessage("0",UI_MASTER_PRODUCT_EDIT,"E","0"), data, setmsg, history, setDrawerState, drawerState)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
		});
	}, []);

	const setMasterData = (data: ProductMasterRelation) => {
		setMaster(data);
		setIndustoryId(data.industoryId);
	};

	// 変更ボタンハンドラ
  const onSubmit = handleSubmit(async (body: any) => {
		// 業種未選択チェック
		if (industoryId === 0) {
			setmsg({
				type: "setMessage",
				payload: {
					...data,
					open: true,
					type: "error",
					message: GetMessage("0",UI_MASTER_PRODUCT_EDIT,"V","0"),
				}
			});
			return;
		}
		// 商品マスタ登録・更新リクエスト
		var requestMaster:RequestProduct = {
			benderName: "",
			productName: "",
			industoryId: industoryId ? industoryId : master ? master.industoryId : 0,
		}

		let beforeBenderName = requestMaster.benderName;
		let beforeProductName = requestMaster.productName;
		let afterBenderName = body.benderName;
		let afterProductName = body.productName;

		requestMaster.benderName = body.benderName;
		requestMaster.productName = body.productName;

		var executeLogData: LogData = {
			eventDate:  moment().format("YYYY-MM-DD HH:mm:ss"),
			logType: "execute", // ログ種別 実行：execute, 結果：result
			result: "", // 実行結果 成功 / 失敗 ※実行時は空文字
			userID: apolloContex.userprofile.userId,
			userName:  apolloContex.userprofile.userName,
			accessToken:  apolloContex.accesstoken,
			displayName: "商品マスタ画面",
			category: "マスタ", // 操作対象 キャンペーン / セグメント etc...
			actionType: "作成",
			accountGroupID: apolloContex.current.accountGroupId,
			accountGroupName: apolloContex.current.accountGroupName,
			accountID: apolloContex.current.accountId,
			accountName: apolloContex.current.accountName,
			campaignID: "", // キャンペーンID
			campaignName: "", // キャンペーン名
			adGroupID: "", // 広告グループID
			adGroupName: "", // 広告グループ名
			targetID: "", // 操作を行うデータのID 実行時は空文字
			targetName: "", // 操作を行うデータの名称 実行時は空文字
			menu: "",
			itemList: [
				{key:"benderName", beforeValue:"", afterValue:afterBenderName},
				{key:"productName", beforeValue:"", afterValue:afterProductName},
			]
		};

		if (props.productId === 0) {
			// URL
			const url = apollo_product_master_path;

			ApolloEventRecord(executeLogData);
			// 商品名称セット
			if (setName) setName(body.productName); 
			// 業種名称セット
			// if (setIndustoryName) setIndustoryName(master?.industoryName); 
			
			// 商品マスタ登録
			ApolloAxios.post(url, requestMaster).then(response => {
				if (response.data.resultCode === 0) {
					executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
					executeLogData.logType = "result";
					executeLogData.result = "成功";
		
					ApolloEventRecord(executeLogData);
					setmsg({
						type: "setMessage",
						payload: {
							...data,
							open: true,
							type: "success",
							message: GetMessage("0",UI_MASTER_PRODUCT_EDIT,"I","0"),
						}
					});
					// 呼び出し元・再読み込み
					setRead(!read);
					setReRead(!reRead);
					handleClose();
					if (setId) setId(response.data.result.productId);
				} else {
					executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
					executeLogData.logType = "result";
					executeLogData.result = "失敗";
		
					ApolloEventRecord(executeLogData);
					console.log(response.data.message);
					setmsg({
						type: "setMessage",
						payload: {
							...data,
							open: true,
							type: "error",
							message: GetMessage("0",UI_MASTER_PRODUCT_EDIT,"E","1"),
						}
					});
				}
			}).catch(err => {
				executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
				executeLogData.logType = "result";
				executeLogData.result = "失敗";
	
				ApolloEventRecord(executeLogData);

				// 認証期間切れ判定とエラーメッセージ表示
				if (!ApolloExpired(err, GetMessage("0",UI_MASTER_PRODUCT_EDIT,"E","1"), data, setmsg, history, setDrawerState, drawerState)) {
					// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
				}
			})
		} else {
			// URL
			const url = apollo_product_master_path + "/" + props.productId;
			executeLogData.actionType = "更新";
			executeLogData.targetID = props.productId.toString();
			executeLogData.logType = "execute";
			executeLogData.result = "";
			executeLogData.itemList = [
				{key:"benderName", beforeValue:beforeBenderName, afterValue:afterBenderName},
				{key:"productName", beforeValue:beforeProductName, afterValue:afterProductName},
			];

		 	ApolloEventRecord(executeLogData);

			// 商品マスタ更新
			ApolloAxios.put(url, requestMaster).then(response => {
				if (response.data.resultCode === 0) {
					executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
					executeLogData.logType = "result";
					executeLogData.result = "成功";
		
					ApolloEventRecord(executeLogData);

					setmsg({
						type: "setMessage",
						payload: {
							...data,
							open: true,
							type: "success",
							message: GetMessage("0",UI_MASTER_PRODUCT_EDIT,"I","1")
						}
					});
					// 呼び出し元・再読み込み
					setRead(!read);
					setReRead(!reRead);
					handleClose();
				} else {
					executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
					executeLogData.logType = "result";
					executeLogData.result = "失敗";
		
					ApolloEventRecord(executeLogData);
					console.log(response.data.message);
					setmsg({
						type: "setMessage",
						payload: {
							...data,
							open: true,
							type: "error",
							message: GetMessage("0",UI_MASTER_PRODUCT_EDIT,"E","2"),
						}
					});
				}
			}).catch(err => {
				executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
				executeLogData.logType = "result";
				executeLogData.result = "失敗";
	
				ApolloEventRecord(executeLogData);
				
				// 認証期間切れ判定とエラーメッセージ表示
				if (!ApolloExpired(err, GetMessage("0",UI_MASTER_PRODUCT_EDIT,"E","2"), data, setmsg, history, setDrawerState, drawerState)) {
					// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
				}
			})
		}
	});

	//// 共通コンポーネントプロパティ定義
	// カテゴリ引数
	var propsCategory:PropsCategory = {
		productId : props.productId,
		industoryId : industoryId,
		industoryName : master ? master.industoryName : "",
		industoryCategoryId : master ? master.industorycategoryId : 0,
		industoryCategoryName : master ? master.industorycategoryName : "",
		setIndustorycategoryId : setIndustoryCategoryId,
		setIndustoryId : setIndustoryId,
		setIndustoryName : setIndustoryName,
		isDisabled: true,
		required: true,
	};
	
	// キャンセルボタンハンドラ
  const handleClose = () => {
		props.close();
	}

	//// 画面表示
	return (
		<Card square variant="outlined" style={{height: 500}}>
			<form noValidate onSubmit={onSubmit}>
				<CardContent style={{padding:10}}>
					<Card className={classes.root} square variant="outlined" style={{height: 420}}>
						<CardContent style={{padding:10}}>
							{/* 商品ID */}
							<Grid item xs={12}>
                <TextField
                  id="productId"
                  name="productId"
                  label="商品ID"
                  fullWidth
                  key={master ? "Loaded" : "Loading"}
                  defaultValue={master && master.productId}
                  autoComplete="商品ID"
									disabled={true}
                />
              </Grid>
							{/* 広告主名 */}
							<Grid item xs={12}>
                <TextField
                  id="benderName"
                  name="benderName"
                  label="広告主名"
                  inputRef={register({
										required: "必須入力項目です。",
										maxLength: {
											value: 255,
											message: "255文字以内で入力して下さい。"
										},
										validate: (e: string) => {
											return checkCommonInvalidTextChar(e);
										}
									})}
                  required
                  fullWidth
                  key={master ? "Loaded" : "Loading"}
                  defaultValue={master && master.benderName}
                  helperText={errors.benderName && errors.benderName.message}
                  error={errors.benderName ? true : false}
                  autoComplete="広告主名"
                />
              </Grid>
							{/* 商品名称 */}
							<Grid item xs={12}>
                <TextField
                  id="productName"
                  name="productName"
                  label="商品名称"
                  inputRef={register({
										required: "必須入力項目です。",
										maxLength: {
											value: 255,
											message: "255文字以内で入力して下さい。"
										},
										validate: (e: string) => {
											return checkCommonInvalidTextChar(e);
										}
                  })}
                  required
                  fullWidth
                  key={master ? "Loaded" : "Loading"}
                  defaultValue={master && master.productName}
                  helperText={errors.productName && errors.productName.message}
                  error={errors.productName ? true : false}
                  autoComplete="商品名称"
                />
              </Grid>
							<Divider/>

							{/* カテゴリ検索 */}
							<ApolloIndustoryCategory propsCategory={propsCategory}/>

							<Divider/>
						</CardContent>
					</Card>
					<Button className={classes.buttonTop} variant="contained" color="primary" onClick={onSubmit}>
							{props.productId === 0 ?
							"新規に登録"
							:
							"変更を保存"
							}
						</Button>
						<Button className={classes.buttonTop} variant="contained" color="primary" onClick={()=>handleClose()}>
						キャンセル
						</Button>
				</CardContent>
			</form>
		</Card>
	);
}
